import {
  ADS_SLIDER
} from "../../constants/actionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  messageId: null,
  lists: []
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case ADS_SLIDER.RESET_ADS_SLIDER: {
      return {
        ...state,
        loader: false,
        alertMessage: '',
        messageId: null
      }
    }

    case ADS_SLIDER.ADD_ADS_SLIDER_REQUEST: {
      return {
        ...state,
        loader: true
      }
    }

    case ADS_SLIDER.ADD_ADS_SLIDER_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 200
      }
    }

    case ADS_SLIDER.ADD_ADS_SLIDER_FAIL: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 203
      }
    }

    case ADS_SLIDER.LIST_ADS_SLIDER_REQUEST: {
      return {
        ...state,
        loader: true
      }
    }

    case ADS_SLIDER.LIST_ADS_SLIDER_SUCCESS: {
      return {
        ...state,
        loader: false,
        messageId: 204,
        lists: action.payload
      }
    }

    case ADS_SLIDER.LIST_ADS_SLIDER_FAIL: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message
      }
    }

    case ADS_SLIDER.DELETE_ADS_SLIDER_REQUEST: {
      return {
        ...state,
        loader: true
      }
    }

    case ADS_SLIDER.DELETE_ADS_SLIDER_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 200,
        lists: action.payload.data
      }
    }

    case ADS_SLIDER.DELETE_ADS_SLIDER_FAIL: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 203
      }
    }

    case ADS_SLIDER.UPDATE_ADS_SLIDER_REQUEST: {
      return {
        ...state,
        loader: true
      }
    }

    case ADS_SLIDER.UPDATE_ADS_SLIDER_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 200,
        lists: action.payload.data
      }
    }

    case ADS_SLIDER.UPDATE_ADS_SLIDER_FAIL: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 203
      }
    }

    default:
      return state;
  }
}
